import $ from "jquery";

var ChartInstance;
window.hasUnsavedChanges = !1,
window.my_mortgages = [],
window.compare_list = [],
window.pay_off_more = void 0;
window.rangeSlider = document.getElementById("silderPayMore");

function dropDownMenu()
{
  const optionMenu = document.querySelector(".select-menu"),
    selectBtn = optionMenu.querySelector(".select-btn"),
    options = optionMenu.querySelectorAll(".option"),
    sBtn_text = optionMenu.querySelector(".sBtn-text");

  selectBtn.addEventListener("click", () =>
    optionMenu.classList.toggle("active")
  );

  options.forEach((option) => {

    if (option.classList.contains('active')) {
      sBtn_text.innerText = option.querySelector('.option-text').textContent;
    }

    option.addEventListener("click", (e) => {
      e.preventDefault();

      const repayentFrequency = e.currentTarget.getAttribute("data-value");
      $(".js-repayment-frequency").val(parseInt(repayentFrequency));

      let selectedOption = option.querySelector(".option-text").innerText;
      sBtn_text.innerText = selectedOption;

      $(".mortgage-frequency").text(selectedOption);

      optionMenu.classList.remove("active");

      pay_off_more = void 0,
      setTimeout((function() {
        return RateActivate()
      }), 100);
    });
  });
}

var RateActivate = function(e) {
      setTimeout((function() {
        runRates({})
      }
      ), 1)
};

function slider()
{
  noUiSlider.create(rangeSlider, {
      start: [100],
      connect: [!0, !1],
      step: 0,
      range: {
          min: 0,
          max: 5e3
      },
      tooltips: !0,
      format: {
          to: function(e) {
              if (0 === (arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 3)){
                return numeral(parseInt(e)).format("$0,0")
              }
          },
          from: function(e) {
              return parseInt(e.replace("$", "").replace(",", ""))
          }
      }
  });

  rangeSlider.noUiSlider.on("change", (function(e, t) {
    pay_off_more = parseInt(e[0].replace("$", "").replace(",", "")),
    pay_off_more && $(".js-your-mortgage-repayments").val(pay_off_more.toLocaleString("en-US")),

    //console.log(pay_off_more);

    $(".js-interest-only-years").val(0).trigger("change");
    setTimeout((function() {
        return RateActivate()
    }), 100);
  }));

  $("body").on("change", ".js-your-mortgage-repayments", (function(e) {
    e.preventDefault();
    var t = $(e.currentTarget);
    pay_off_more = parseInt(t.val().replace("$", "").replace(",", "")),
    pay_off_more > parseInt(t.attr("max")) && (t.val(parseInt(t.attr("max")).toLocaleString("en-US")),
    pay_off_more = parseInt(t.attr("max"))),
    pay_off_more < parseInt(t.attr("min")) && (t.val(parseInt(t.attr("min")).toLocaleString("en-US")),
    pay_off_more = parseInt(t.attr("min"))),
    $(".js-interest-only-years").val(0).trigger("change");

    setTimeout((function() {
      return RateActivate()
    }), 100);
    
  }));
}

function chart()
{
  let ctx = document.getElementById("mortgage-results").getContext("2d");
  return new Chart(ctx, {
    type: "bar",
    defaults: {
      color: "#ffffff",
      font: {
        family: "brandon-grotesque",
        style: "bold"
      }
    },
    data: {
        labels: [],
        datasets: [{
            borderWidth: 0,
            fill: !0,
            pointBackgroundColor: "rgba(255, 255, 255, 0)",
            pointBorderColor: "rgba(255, 255, 255, 0)"
        }, {
            borderWidth: 0,
            fill: !0,
            pointBackgroundColor: "rgba(255, 255, 255, 0)",
            pointBorderColor: "rgba(255, 255, 255, 0)"
        }]
    },
    options: {
      animation: !1,
      layout: {
          responsive: !0,
          padding: {
              top: 20
          }
      },
      plugins: {
          legend: {
              display: !1
          },
          tooltip: {
              enabled: !1,
              mode: "index",
              external: function(e) {
                var tooltip = document.getElementById("chartjs-tooltip");
                
                if (tooltip || ((tooltip = document.createElement("div")).id = "chartjs-tooltip",
                document.body.appendChild(tooltip)),
                0 !== e.tooltip.opacity) {
                    var number = 0;
                    if (e.tooltip.body) {
                        var titles = e.tooltip.title || [];
                        var infos = e.tooltip.body.map((function(e) {
                            var numberArr = e.lines[0].split(":");
                              number += parseInt(numberArr[1].replace(/,/g, ""));
                            var type = "";
                            return "Remaining Interest To Pay" === numberArr[0] && (type = "Interest"),
                            "Total Mortgage" === numberArr[0] && (type = "Principal"),
                            '<div class="toolTipEntry__title">'.concat(type, ':</div><div class="toolTipEntry__value">').concat(numeral(numberArr[1].trim()).format("$0,0"), "</div>")
                        }));

                        var iterate = "";
                        titles.forEach((function(e) {
                          iterate += "In " + e + " Years"
                        }));

                        infos.forEach((function(e, t) {
                            iterate += '\n<div class="toolTipEntry order-'.concat(7 - t, " toolTipEntry--").concat(function(e) {
                                return e.includes("Interest") ? "Interest" : e.includes("Principal") ? "Principal" : void 0
                            }(e), '">\n <div class="toolTipEntry__colour"></div>\n   ').concat(e, "\n</div>")
                        }));

                        iterate += '\n<div class="toolTipEntry order-12">\n <div class="toolTipEntry__title">Total Balance:</div>\n <div class="toolTipEntry__value">'.concat(numeral(number).format("$0,0"), "</div>\n</div>");
                        tooltip.innerHTML = iterate;
                    }

                    var canvas = e.chart.canvas.getBoundingClientRect();
                    tooltip.style.opacity = 1;
                    tooltip.style.left = canvas.left + window.pageXOffset + e.tooltip.caretX + "px";
                    tooltip.style.top = canvas.top + window.pageYOffset + e.tooltip.caretY + "px";
                } else {
                  tooltip.style.opacity = 0
                }
            }
          }
      },
      scales: {
        x: {
          stacked: !0,
          grid: {
              color: "#071845"
          },
          ticks: {
            color: 'white'
          
          }
        },
        y: {
          stacked: !0,
          grid: {
              color: "#273b60"
          },
          ticks: {
              color: 'white', 
              callback: function(e) {
                  return "".concat(numeral(e).format(e > 1099999 ? "$0.0a" : "$0a"), "  ")
              }
          }
        }
      },

    }
  });
}

function sanitize(e, t) 
{
  (null == t || t > e.length) && (t = e.length);
  for (var a = 0, n = new Array(t); a < t; a++)
      n[a] = e[a];
  return n
}

function formatObject(e) 
{
return function(e) {
    if (Array.isArray(e))
        return sanitize(e)
}(e) || function(e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"])
        return Array.from(e)
}(e) || function(e, t) {
    if (!e)
        return;
    if ("string" == typeof e)
        return sanitize(e, t);
    var a = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === a && e.constructor && (a = e.constructor.name);
    if ("Map" === a || "Set" === a)
        return Array.from(e);
    if ("Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a))
        return sanitize(e, t)
}(e) || function() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
}()
}

function loanData()
{
  return [{
    id: 1,
    rank: null,
    principal: parseInt($(".js-mortgage-loan-amount").val().replace(/,/g, "")),
    interest_rate: parseFloat($(".js-mortgage-interest-rate").val().replace(/,/g, "")),
    term: parseFloat($(".js-loan-term").val().replace(/,/g, "")),
    total_interest_paid: 0,
    total_interest_paid_nudge: 0
  }];
}

function events()
{

  $(document).on("keyup", ".js-number-input", (function(e) {
    if ("" === window.getSelection().toString() && -1 === $.inArray(e.keyCode, [38, 40, 37, 39])) {
        var term,
          element = $(this), 
          value = element.val();

        element.hasClass("js-mortgage-interest-rate") || element.hasClass("js-loan-term") ? (term = value.replace(/[^0-9.]|\.(?=.*\.)/g, ""),
        element.hasClass("js-loan-term") && term > 30 && (term = 30)) : term = (term = value.replace(/[\D\s\._\-]+/g, "")) ? parseInt(term, 10) : 0,
        element.val((function() {
            return 0 === term ? 0 : term.toLocaleString("en-US")
        }))
    }
  }));

  $(document).on("change", ".js-mortgage-loan-amount,.js-loan-term,.js-mortgage-interest-rate", (function(e) {
    e.preventDefault(),
    setTimeout((function() {
      return RateActivate()
    }), 110);
  }));

}

function rasterize(e, t) 
{
  (null == t || t > e.length) && (t = e.length);
  for (var a = 0, n = new Array(t); a < t; a++) n[a] = e[a];
  return n;
}

var formatMortgage = function (e, t, a, n, o) 
{
  return 0 === e ? t : a + n + o;
}

function spreadInstance(e) 
{
  return function (e) {
    if (Array.isArray(e)) return rasterize(e);
  }(e) || function (e) {
    if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
  }(e) || function (e, t) {
    if (!e) return;
    if ("string" == typeof e) return rasterize(e, t);
    var a = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === a && e.constructor && (a = e.constructor.name);
    if ("Map" === a || "Set" === a) return Array.from(e);
    if ("Arguments" === a || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(a)) return rasterize(e, t);
  }(e) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}


function Process (e, t, a, n) 
{

 var o, r = {};
  (o = e.sort(function (e, t) {
    return t.interest_rate - e.interest_rate;
  })).forEach(function (e, t) {

    Object.assign(e, {rank: t + 1});
  }), (e = o).forEach(function (e) {

    if (
      void 0 !== e.principal && 
      void 0 !== e.interest_rate && 
      void 0 !== e.term && 
      e.principal > 0 && 
      e.interest_rate > 0 && 
      e.term > 0
    ){

      var a = function (e, t) {
        return e / 100 / t;
      }(e.interest_rate, n);

      Object.assign(e, {
        total_interest_paid: 0, 
        total_interest_paid_nudge: 0, 
        per_period_interest_rate: a,
        minimum_repayment: e.principal / ((1 - Math.pow(1 + a, -n * (e.term - t))) / a), 
        number_of_periods: e.term * n
      });
    }

  });

  for (var i = Math.max.apply(Math, spreadInstance(e.map(function (e) {
    return e.term || 0;
  }))), s = i * n, l = e.reduce(function (e, t) {
    return e + t.principal;
  }, 0), c = [], d = function (a) {
    var o = {period: a, mortgages: {}};
    e.forEach(function (e) {
      if (void 0 !== e.principal && void 0 !== e.interest_rate && void 0 !== e.term && e.principal > 0 && e.interest_rate > 0 && e.term > 0) {
        var r = 0 === a ? 0 : e.per_period_interest_rate * c[a - 1].mortgages["mortgage_".concat(e.rank)].closing_amount, i = function (e, t, a, n, o) {
          return -1 * (Math.min(e), t > a * n ? e : o);
        }(e.minimum_repayment, a, t, n, r), s = 0 === a ? e.principal : formatMortgage(a, e.principal, c[a - 1].mortgages["mortgage_".concat(e.rank)].closing_amount, r, i);
        s < 0 && (s = 0), Object.assign(e, {total_interest_paid: e.total_interest_paid + r}), o.mortgages["mortgage_".concat(e.rank)] = {interest_accrued: r, closing_amount: s, minimum_repayment: i};
      }
    }), o.minimum_repayments = Object.values(o.mortgages).reduce(function (e, t) {
      return e + t.minimum_repayment;
    }, 0), o.opening = Object.values(o.mortgages).reduce(function (e, t) {
      return e + t.closing_amount;
    }, 0), o.closing_initial = 0 === a ? l : o.opening, o.closing_final = o.closing_initial, c.push(o);
  }, u = 0; u < s + 1; u++) d(u);
  for (var m = [], g = function (o) {
    var r = {period: o, mortgages: {}};
    r.closing_initial = 0 === o ? l : 0, r.opening = l > 0 ? l : 0, e.forEach(function (e) {
      if (void 0 !== e.principal && void 0 !== e.interest_rate && void 0 !== e.term && e.principal > 0 && e.interest_rate > 0 && e.term > 0) {
        var a = e.principal, i = 0 === o ? 0 : e.per_period_interest_rate * m[o - 1].mortgages["mortgage_".concat(e.rank)].closing_mortgage_balance_post_nudge, s = function (e, t, a, n, o, r) {
          return -1 * Math.min(e + r, a > n * o ? t : r);
        }(0 === o ? e.principal : m[o - 1].mortgages["mortgage_".concat(e.rank)].closing_mortgage_balance_post_nudge, e.minimum_repayment, o, t, n, i), l = 0 === o ? e.principal : formatMortgage(o, e.principal, m[o - 1].mortgages["mortgage_".concat(e.rank)].closing_mortgage_balance_post_nudge, i, s);
        l < 0 && (l = 0), Object.assign(e, {total_interest_paid_nudge: e.total_interest_paid_nudge + i}), 0 !== o && (r.closing_initial = r.closing_initial + l), r.mortgages["mortgage_".concat(e.rank)] = {interest_accrued: i, closing_mortgage_balance_post_nudge: a, closing_mortgage_balance_pre_nudge: l, minimum_repayment_nudge: s};
      }
    }), r.minimum_repayments = Object.values(r.mortgages).reduce(function (e, t) {
      return e + t.minimum_repayment_nudge;
    }, 0), r.extra_payment = 0 === o ? 0 : -1 * (parseFloat(a) + parseFloat(r.minimum_repayments));
    var i = 0, s = 0;
    e.forEach(function (e) {
      if (void 0 !== e.principal && void 0 !== e.interest_rate && void 0 !== e.term && e.principal > 0 && e.interest_rate > 0 && e.term > 0) {
        s += r.mortgages["mortgage_".concat(e.rank)].closing_mortgage_balance_pre_nudge;
        var t = Math.max(-s, r.extra_payment) - i;
        i += t, Object.assign(r.mortgages["mortgage_".concat(e.rank)], {repayment_nudge: t}), Object.assign(r.mortgages["mortgage_".concat(e.rank)], {closing_mortgage_balance_post_nudge: r.mortgages["mortgage_".concat(e.rank)].closing_mortgage_balance_pre_nudge + t});
      }
    }), r.closing_final = r.closing_initial + r.extra_payment, r.opening = r.closing_final > 0 ? r.closing_final : 0, m.push(r);
  }, _ = 0; _ < s + 1; _++) g(_);
  for (var p = function (t) {
    e.forEach(function (e) {
      if (void 0 !== e.principal && void 0 !== e.interest_rate && void 0 !== e.term && e.principal > 0 && e.interest_rate > 0 && e.term > 0) {
        var a = c[t].mortgages["mortgage_".concat(e.rank)];
        Object.assign(a, {interest_remaining_to_pay_nominal: 0 === t ? e.total_interest_paid : c[t - 1].mortgages["mortgage_".concat(e.rank)].interest_remaining_to_pay_nominal - c[t].mortgages["mortgage_".concat(e.rank)].interest_accrued});
        var n = m[t].mortgages["mortgage_".concat(e.rank)], o = 0 === t ? e.total_interest_paid_nudge : m[t - 1].mortgages["mortgage_".concat(e.rank)].interest_remaining_to_pay_nudge - m[t].mortgages["mortgage_".concat(e.rank)].interest_accrued;
        isNaN(o) && (o = 0), Object.assign(n, {interest_remaining_to_pay_nudge: o > 1.8 ? o : 0});
      }
    });
  }, f = 0; f < s + 1; f++) p(f);
  var y = Object.values(e).reduce(function (e, t) {
    return e + t.minimum_repayment;
  }, 0), v = Object.values(e).reduce(function (e, t) {
    return e + t.total_interest_paid;
  }, 0), h = l + v, b = Object.values(e).reduce(function (e, t) {
    return e + t.total_interest_paid_nudge;
  }, 0), j = m[0] && m[0].opening ? parseInt(m[0].opening) + parseInt(b) : 0, w = m.findIndex(function (e) {
    return e.opening <= 0;
  });
  return r.my_mortgages = e, r.table = c, r.table_nudge = m, r.repayments_per_year = n, r.repayments = y, r.total_interest_paid = v, r.total_you_pay = h, r.time_to_pay_off = i, r.pay_off_more = a, r.total_interest_paid_nudge = b, r.total_you_pay_nudge = j, r.time_to_pay_off_nudge = w, r.years_to_pay_off_nudge = i - w / 12, r.years_mortgage_free_sooner = i - w / n, r;
};

 /* CHART JS */
  // var t = parseInt($(".js-interest-only-years").val())
  //   , a = parseInt($(".js-term-selector").val())
  //   , i = parseInt($(".js-repayment-frequency").val())
  //   , d = R(my_mortgages, t, pay_off_more, i, V);
  var t = 0 // js-interest-only-years
    , a = $(".js-loan-term").val() // js-term-selector
    , i = $(".js-repayment-frequency").val() // js-repament-frequency
    , d = d; // R(my_mortgages, t, pay_off_more, i, V)
  var J, V = "https://lighthousedevf.wpengine.com" === window.location.origin;

  function processMortgage(e) 
  {

    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 1
      , a = arguments.length > 2 && void 0 !== arguments[2] && arguments[2]
      , n = [];
    if (0 === e.my_mortgages.length || void 0 === e.my_mortgages[0])
        return n;
    var o = Math.max.apply(Math, spreadInstance(e.my_mortgages.map((function(e) {
        return e.term || 0
    }
    ))))
      , r = Math.ceil(o * t);
    if (spreadInstance(Array(r)).forEach((function(a, o) {
        var r = {
            period: o
        };
        r.model_period = o * e.repayments_per_year / t,
        r.total_mortage_nominal = 0 === o ? e.table[0].closing_initial : e.table[Math.floor(r.model_period)].closing_initial * (1 - r.model_period + Math.floor(r.model_period)) + e.table[Math.ceil(r.model_period)].closing_initial * (r.model_period - Math.floor(r.model_period)),
        r.interest_remaining_to_pay_nominal = 0 === o ? Object.values(e.table[0].mortgages).reduce((function(e, t) {
            return Math.max(e + t.interest_remaining_to_pay_nominal, 0)
        }
        ), 0) : Object.values(e.table[Math.floor(r.model_period)].mortgages).reduce((function(e, t) {
            return Math.max(e + t.interest_remaining_to_pay_nominal, 0)
        }
        ), 0) * (1 - r.model_period + Math.floor(r.model_period)) + Object.values(e.table[Math.ceil(r.model_period)].mortgages).reduce((function(e, t) {
            return Math.max(e + t.interest_remaining_to_pay_nominal, 0)
        }
        ), 0) * (r.model_period - Math.floor(r.model_period)),
        r.total_mortage_nudge = 0 === o ? e.table_nudge[0].closing_initial : e.table_nudge[Math.floor(r.model_period)].closing_initial * (1 - r.model_period + Math.floor(r.model_period)) + e.table_nudge[Math.ceil(r.model_period)].closing_initial * (r.model_period - Math.floor(r.model_period)),
        r.interest_remaining_to_pay_nudge = 0 === o ? Object.values(e.table_nudge[0].mortgages).reduce((function(e, t) {
            return Math.max(e + t.interest_remaining_to_pay_nudge, 0)
        }
        ), 0) : Object.values(e.table_nudge[Math.floor(r.model_period)].mortgages).reduce((function(e, t) {
            return Math.max(e + t.interest_remaining_to_pay_nudge, 0)
        }
        ), 0) * (1 - r.model_period + Math.floor(r.model_period)) + Object.values(e.table_nudge[Math.ceil(r.model_period)].mortgages).reduce((function(e, t) {
            return Math.max(e + t.interest_remaining_to_pay_nudge, 0)
        }
        ), 0) * (r.model_period - Math.floor(r.model_period)),
        n.push(r)
    }
    )),
    a) {
        var i = [];
        e.table_nudge.forEach((function(e) {
            var t = {
                period: e.period,
                opening: S()(e.opening).format("$0,0.00"),
                min_repayments: S()(e.minimum_repayments).format("$0,0.00"),
                interest: S()(Object.values(e.mortgages).reduce((function(e, t) {
                    return e + t.interest_accrued
                }
                ), 0)).format("$0,0.00"),
                closing_initial: S()(e.closing_initial).format("$0,0.00"),
                extra_payment: S()(e.extra_payment).format("$0,0.00"),
                closing_final: S()(e.closing_final).format("$0,0.00"),
                intrst_rmnng_pay_ndge: S()(Object.values(e.mortgages).reduce((function(e, t) {
                    return e + t.interest_remaining_to_pay_nudge
                }
                ), 0)).format("$0,0.00")
            };
            Object.keys(e.mortgages).forEach((function(a) {
                t["Intrst_".concat(a.replace("mortgage_", ""))] = S()(e.mortgages[a].interest_accrued).format("$0,0.00")
            }
            )),
            Object.keys(e.mortgages).forEach((function(e) {
                return t["-"] = ""
            }
            )),
            Object.keys(e.mortgages).forEach((function(a) {
                t["Min_".concat(a.replace("mortgage_", ""))] = S()(e.mortgages[a].minimum_repayment_nudge).format("$0,0.00")
            }
            )),
            Object.keys(e.mortgages).forEach((function(e) {
                return t["/"] = ""
            }
            )),
            Object.keys(e.mortgages).forEach((function(a) {
                t["CLS_PRE_".concat(a.replace("mortgage_", ""))] = S()(e.mortgages[a].closing_mortgage_balance_pre_nudge).format("$0,0.00")
            }
            )),
            Object.keys(e.mortgages).forEach((function(e) {
                return t._ = ""
            }
            )),
            Object.keys(e.mortgages).forEach((function(a) {
                t["NUDGE ".concat(a.replace("mortgage_", ""))] = S()(e.mortgages[a].repayment_nudge).format("$0,0.00")
            }
            )),
            Object.keys(e.mortgages).forEach((function(e) {
                return t["*"] = ""
            }
            )),
            Object.keys(e.mortgages).forEach((function(a) {
                t["CLS_PST_".concat(a.replace("mortgage_", ""))] = S()(e.mortgages[a].closing_mortgage_balance_post_nudge).format("$0,0.00")
            }
            )),
            Object.keys(e.mortgages).forEach((function(e) {
                return t["!"] = ""
            }
            )),
            Object.keys(e.mortgages).forEach((function(a) {
                t["INTRST_REM_".concat(a.replace("mortgage_", ""))] = S()(e.mortgages[a].interest_remaining_to_pay_nudge).format("$0,0.00")
            }
            )),
            i.push(t)
        }
        )),
        $(".js-results").html('<table id="tbody"></table>');
        var s = document.getElementById("tbody")
          , l = Object.keys(i[0])
          , c = document.createElement("thead")
          , d = document.createElement("tr");
        l.forEach((function(e) {
            var t = document.createElement("th");
            t.innerText = e,
            d.appendChild(t)
        }
        )),
        c.appendChild(d),
        s.append(d),
        i.forEach((function(e) {
            var t = document.createElement("tr");
            Object.values(e).forEach((function(e) {
                var a = document.createElement("td");
                a.innerText = e,
                t.appendChild(a)
            }
            )),
            s.appendChild(t)
        }
        ))
    }
  return n
}(d, a, V);

function runRates()
{
  var loan = loanData();

  //Process(mortgages, interestonlyyears, payoffmore, repaymentfrequency, true);

  var data = Process(loan, 0, pay_off_more, $(".js-repayment-frequency").val(), true);
  //console.log(loan);
  //console.log(d);


  // Repayment Frequency
  // 52 weekly
  // 26 fortnightly
  // 12 yearly

  if (ChartInstance) {
    ChartInstance.destroy();
  }

  ChartInstance = chart();

  var current = 0;
  if (data.my_mortgages.forEach((function(e) {
        return current += e.minimum_repayment || 0
      })), current = Math.ceil(current), processMortgage) {

      var chartDataTotalArr = [], chartDataRemainingArr = [];
      
      var myMortgage = processMortgage(data);

      myMortgage.forEach((function(e) {
        chartDataTotalArr.push(pay_off_more && pay_off_more > current ? e.total_mortage_nudge : e.total_mortage_nominal),
        chartDataRemainingArr.push(pay_off_more && pay_off_more > current ? e.interest_remaining_to_pay_nudge : e.interest_remaining_to_pay_nominal)
      }));

      window.chart = ChartInstance;
      var listMortgage = [
        {
          plots: chartDataTotalArr,
          label: "Total Mortgage",
          color: "#6ccde5"
        }, 
        {
            plots: chartDataRemainingArr,
            label: "Remaining Interest To Pay",
            color: "#3db4a6"
        }
      ];
      
      var labels = formatObject(Array(myMortgage.length + 1)).map((function(e, index) {
          return index
      }
      ));

      ChartInstance.data.labels = labels;

      listMortgage.forEach(function(e, index) {
        ChartInstance.data.datasets[index].data = e.plots,
        ChartInstance.data.datasets[index].backgroundColor = e.color,
        ChartInstance.data.datasets[index].label = e.label
      });

      rangeSlider.noUiSlider.updateOptions({
        range: {
            min: current,
            max: 2 * current
        }
      });
      rangeSlider.noUiSlider.set(current, !0);

      $(".js-your-mortgage-repayments").val(current.toLocaleString("en-US"));
      $(".js-your-mortgage-repayments").attr("min", pay_off_more == null ? current : pay_off_more);
      $(".js-your-mortgage-repayments").attr("max", 2 * pay_off_more == null ? current : pay_off_more);

      const totalRepayments = new countUp.CountUp("js-your-mortgage-repayments-text", pay_off_more == null ? current : pay_off_more, {
        decimalPlaces: 0,
        duration: 1
      });
      totalRepayments.start();
    
      const totalInterest = new countUp.CountUp("js-total-interest", data.total_interest_paid, {
        decimalPlaces: 0,
        duration: 1
      });
      totalInterest.start();
    
      const totalPaid = new countUp.CountUp("js-total-paid", data.total_you_pay, {
        decimalPlaces: 0,
        duration: 1
      });
      totalPaid.start();

      console.log('test123')

      pay_off_more && pay_off_more > current ? (
        console.log('Jed Pogi 1'),
        rangeSlider.noUiSlider.set(pay_off_more),
        pay_off_more && $(".js-your-mortgage-repayments").val(pay_off_more.toLocaleString("en-US")),
        totalInterest.update(data.total_interest_paid_nudge),
        totalPaid.update(data.total_you_pay_nudge),
        $(".interest_only_years_holder__context").show(),
        $(".interest_only_years_holder .select2").css({
            opacity: .2,
            pointerEvents: "none"
        }),
        $(".pay_off_more__context").hide(),
        $("#silderPayMore").css({
            opacity: 1,
            pointerEvents: "initial"
        }),
        $(".js-mortgage-free-sooner").html("<br> ".concat(Math.floor(12 * data.years_mortgage_free_sooner), " months "))
      ) : "0" !== $(".js-interest-only-years").val() ? (
        $(".js-mortgage-free-sooner").html("<br> 0 months "),
        console.log('Jed Pogi 2'),
        totalInterest.update(data.total_interest_paid),
        totalPaid.update(data.total_you_pay),
        // n.update(data.repayments),
        $(".interest_only_years_holder__context").hide(),
        $(".interest_only_years_holder .select2").css({
            opacity: 1,
            pointerEvents: "initial"
        }),
        $(".pay_off_more__context").show()
        // $("#silderPayMore").css({
        //     opacity: .2,
        //     pointerEvents: "none"
        // })
      ) : (
        console.log('Jed Pogi 3'),
        totalInterest.update(data.total_interest_paid),
        totalPaid.update(data.total_you_pay),
        // n.update(data.repayments),
        $(".interest_only_years_holder__context").hide(),
        $(".interest_only_years_holder .select2").css({
            opacity: 1,
            pointerEvents: "initial"
        }),
        $(".pay_off_more__context").hide(),
        $("#silderPayMore").css({
            opacity: 1,
            pointerEvents: "initial"
        })
      );

      ChartInstance.update();
  }

}

window.addEventListener('load', function(event) {
  if ($(".select-btn").length){
    /* DROPDOWN */
    dropDownMenu()

    /* NOUI SLIDER */
    slider();

    /* EVENTS */
    events();

    /* PROCESS RATES */
    runRates();
  }

  
});